module.exports = __webpack_public_path__ + "static/media/36-1.2bcd435f.mp3";